import React from 'react';

import { Skeleton, Typography } from 'lighthouse';

import { rialToToman } from '@/utilities/Financial';
import { withSeparator } from '@/utilities/withSeparator';

export interface PricingDetailProps {
    available: boolean | number;
    isPriceLoading?: boolean;
    discount?: number | null;
    sellingPrice?: number | null;
    price?: number;
}

const PricingDetail = ({ available, isPriceLoading, discount, sellingPrice, price }: PricingDetailProps) => {
    return (
        <>
            {!!available && (
                <div>
                    {isPriceLoading ? (
                        <Skeleton width={140} height={40} className='scale-100' />
                    ) : discount && sellingPrice ? (
                        <div className='flex flex-col items-end'>
                            <div className='flex items-center gap-2'>
                                <div className='inline-flex h-5 shrink-0 items-center justify-center rounded-lg bg-[#fbbf24] px-2'>
                                    <Typography
                                        variant='caption'
                                        fontWeight={600}
                                        color='blackHighEmphasis'
                                        className='!m-0 whitespace-nowrap !text-[10px] !leading-none'
                                        component='span'>
                                        {discount}٪
                                    </Typography>
                                </div>
                                <Typography
                                    variant='caption'
                                    color='blackLowEmphasis'
                                    component='p'
                                    className='flex items-center gap-1 text-nowrap text-xs line-through'>
                                    {withSeparator(rialToToman(price ?? 0))} تومان
                                </Typography>
                            </div>
                            <Typography variant='h6' fontWeight={700} color='primary' component='span'>
                                {withSeparator(rialToToman(sellingPrice))}
                                <span className='text-xs font-bold text-blackHighEmphasis'>&nbsp;تومان</span>
                            </Typography>
                        </div>
                    ) : (
                        <Typography variant='h5' fontWeight={600} color='primary' component='span'>
                            {withSeparator(rialToToman(price ?? 0))}
                            <span className='text-xs font-normal text-blackHighEmphasis'>&nbsp;تومان</span>
                        </Typography>
                    )}
                </div>
            )}
        </>
    );
};

export default PricingDetail;
